import { cn } from '@/lib/utils'

/// One height for the phone chart. `h-full` is not included: the frame helper
/// already adds it for desktop, and tailwind-merge lets this class replace it.
export const MOBILE_COLLECTION_CHART_CLASS = 'h-[55vh] min-h-[320px] w-full'

/// Desktop chart fills the CSS pane. The canvas inside TvChart keeps its own
/// 320px floor so a zero-height parent cannot collapse the plot.
export const DESKTOP_COLLECTION_CHART_CLASS = 'h-full min-h-0 w-full'

/// `className` wins over the default `h-full`, so a caller that passes
/// `h-[55vh]` does not also keep `h-full`.
export function collectionChartFrameClass(height: number | undefined, className?: string): string {
	return cn('w-full', height ? undefined : 'h-full', className)
}
